const state = {
  staffCode: ''
}

const mutations = {
  SET_STAFF(state, staffCode) {
    state.staffCode = staffCode
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
